import React from 'react';

// Material ui
import { Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';
import Radio from '@components/UI-KIT/Radio';
import CardItem from '@components/UI-KIT/CardItem';
import Footer from '@components/UI-KIT/Footer';
import Button from '@components/UI-KIT/Button';

// Icons
import { BankOutlined, CashOutlined } from '@/assets/icons';


interface Props {
    accountType: string;
    setAccountType: React.Dispatch<React.SetStateAction<string>>;
    setActiveStep: React.Dispatch<React.SetStateAction<number>>;
}
const FirstStep: React.FC<Props> = ({
    accountType,
    setAccountType,
    setActiveStep
}) => {

    return (
        <>
            <Typography
                variant="input-head"
                color="primary-dark"
                className="AOL-Account-stepper-type-label"
            >
                Tipo de cuenta
            </Typography>
            <Grid
                container
                direction="column"
                spacing={3}
            >
                <CardItem
                    onHoverEffect
                    variant={accountType === 'Bank' ? 'outlined' : 'normal'}
                    onClick={() => accountType !== 'Bank' && setAccountType('Bank')}
                >
                    <Radio
                        checked={accountType === 'Bank'}
                    />
                    <BankOutlined />
                    <Typography
                        variant="h4"
                        color="primary-dark"
                        className="AOL-Account-stepper-label"
                    >
                        Bancaria
                    </Typography>
                </CardItem>
                <CardItem
                    onHoverEffect
                    variant={accountType === 'Cash' ? 'outlined' : 'normal'}
                    onClick={() => accountType !== 'Cash' && setAccountType('Cash')}
                >
                    <Radio
                        checked={accountType === 'Cash'}
                    />
                    <CashOutlined />
                    <Typography
                        variant="h4"
                        color="primary-dark"
                        className="AOL-Account-stepper-label"
                    >
                        Efectivo
                    </Typography>
                </CardItem>
            </Grid>
            <Footer
                className="AOL-Account-stepper-footer"
            >
                <Grid
                    container
                    direction="column"
                >
                    <Button
                        label="Siguiente"
                        onClick={() => setActiveStep(1)}
                    />
                </Grid>
            </Footer>
        </>
    );
};

export default FirstStep;